import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaRating from './VaRating.vue'
export { VaRatingItem } from './components/VaRatingItem'

export const VaRating = withConfigTransport(_VaRating)
